export const MAX_MESSAGE_LENGTH = 1000
export const MAX_MESSAGE_COUNT_IN_3_HOURS = 25

// it is for the array of messages
export const MAX_MESSAGE_LENGTH_API_REQUEST = 2000

export const EVALUATION_BUTTON_TEXT = 'Start Evaluation'
export const AI_GUIDED_LESSON_BUTTON_TEXT = 'Generate AI Guided Lesson'

export const AI_SUBSCRIPTION_TYPES = {
  BETA: 'beta',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  TRIAL: 'trialing',
  CANCELED: 'canceled',
  PAST_DUE: 'past_due',
} as const

// subscription packages (MORE TO COME)
export const SUBSCRIPTION_PACKAGES = {
  PREMIUM: 'premium',
  AD_FREE: 'ad-free',
} as const

export const AI_EXPIRY_AFTER_DAYS: Record<keyof typeof AI_SUBSCRIPTION_TYPES, number> = {
  BETA: 7,
  MONTHLY: 31,
  YEARLY: 365,
  TRIAL: 7,
  CANCELED: 0,
  PAST_DUE: 0,
} as const

export const AI_SUBSCRIPTION_PRICES = {
  MONTHLY: 4.99,
  YEARLY: 39.99,
} as const

export const AD_FREE_SUBSCRIPTION_PRICES = {
  MONTHLY: 1.99,
  YEARLY: 18.99,
} as const

// number of beta subscribers allowed
export const AI_BETA_SUBSCRIBERS_LIMIT = 50

// cookie key for server side subscription check
export const COOKIE_KEY_FOR_SERVER_SIDE_SUBSCRIPTION_CHECK = 'tm_usr_pref_v2'

// Encoded values to obscure the actual meaning
export const ENCODED_COOKIE_VALUES_FOR_SERVER_SIDE_SUBSCRIPTION_CHECK = {
  ACTIVE: 'a7x9k2',
  INACTIVE: 'b3m8n1',
}
